<div class="container-fluid">
	<div class="row flex-nowrap">

		<div id="menu-panel" class="col-auto d-none d-md-block">

			<div class="menu-header text-center">
				<i class="fa fa-4x fa-print page-icon"></i>
			</div>

			<div>
				<button id="filter-btn" class="btn btn-dark pl-3 pr-3 mb-2" onclick="Anvil.page.searchModal()"><i class="fa fa-lg mb-2 fa-filter"></i><br />Szűrő<span id="filter-btn-badge" class="badge rounded-pill bg-danger ms-1 d-none"></span></button><br />
				<button class="btn btn-primary pl-3 pr-3" onclick="Anvil.page.refresh()"><i class="fa fa-lg mb-2 fa-sync-alt"></i><br />Frissítés</button>
				<hr />
				<div class="alert bg-dark p-1">
					<% for (let m = 1; m <= 12; m++) { %>
						<div class="text-end mb-1">
							<small class="float-start" style="padding-top:2px;"><strong><%- [ 'Jan', 'Feb', 'Már', 'Ápr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sze', 'Okt', 'Nov', 'Dec' ][m - 1] %></strong></small>
							<small style="color:goldenrod;"><%= Anvil.numeral(months[m - 1].gross_total).format('0,0') %></small><br />
							<small style="color:orangered;"><%= Anvil.numeral(months[m - 1].gross_total - months[m - 1].paid_amount).format('0,0') %></small>
						</div>
					<% } %>
				</div>
			</div>
		</div>

		<div class="col list-panel">

			<div class="row">
				<div class="col">

					<div class="page-header">

						<ol class="breadcrumb">
							<li class="breadcrumb-item"><a href="/home"><i class="fa fa-home"></i></a></li>
							<li class="breadcrumb-item">Partnerek</li>
						</ol>

						<div class="float-end">
							<div class="row g-2">
								<div class="col d-none d-lg-block" style="width:280px;">
									<%- include('/ui/form', {
										params: [ 'search_3', search ],
										fields: [
											{
												type: 'select',
												inline: true,
												name: 'company_tag_id',
												title: 'Üzletág',
												params: {
													maxItems: 1,
													options: [ ...company_tags.data ],
													valueField: 'id',
													labelField: 'name',
													searchField: [ 'name' ],
													render: {
														item: (item, esc) => `<div>${esc(item.name)}</div>`,
														option: (item, esc) => `<div class="option">${esc(item.name)}</div>`
													},
													placeholder: '[ minden üzletág ]'
												},
												unset_value: null,
												prepend: '<span class="input-group-text"><i class="fa fa-tag"></i></span>',
												append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.company_tag_id = null;"><i class="fa fa-fw fa-times"></i></button>',
												update: (value) => {
													Anvil.page.quickSearch()
												}
											}
										]
									}) %>
								</div>
								<div class="col-auto d-none d-lg-block" style="width:120px;">
									<%- include('/ui/form', {
										params: [ 'search_2', search ],
										fields: [
											{
												type: 'select',
												inline: true,
												name: 'year',
												title: 'Év',
												params: {
													maxItems: 1,
													options: (() => {
														const currentYear = new Date().getFullYear()
														const options = []
														for (let year = 2019; year <= currentYear; year++) {
															options.push({ value: year.toString(), name: year.toString() })
														}
														return options
													})(),
													valueField: 'value',
													labelField: 'name',
												},
												prepend: '<span class="input-group-text"><i class="fa fa-calendar"></i></span>',
												update: (value) => {
													Anvil.route(Anvil.href('/company/invoicing', {
														year: value,
														expression: search.expression,
														sort_order: search.sort_order
													}))
												}
											}
										]
									}) %>
								</div>
								<div class="col-auto" style="width:300px; max-width:50vw;">
									<%- include('/ui/form', {
										params: [ 'search', search ],
										fields: [
											{
												type: 'text',
												inline: true,
												name: 'expression',
												title: 'Szöveges keresés',
												attributes: {
													placeholder: 'Keresés...'
												},
												append: '<span class="input-group-text"><i class="fa fa-search"></i></span>',
												update: (value) => {
													Anvil.page.quickSearch()
												}
											}
										]
									}) %>
								</div>
								<div class="col-auto d-lg-none">
									<button id="filter-btn" class="btn btn-dark" onclick="Anvil.page.searchModal()"><i class="fa fa-fw fa-filter"></i></button>
								</div>
							</div>
						</div>
						<h2 class="pt-1">Számlázás</h2>
					</div>

					<%
					const render_month = (value) => {
						if (value) {
							const inv = []
							const colors = ['danger', 'dim', 'warning', 'success', 'info']
							var total_debit = 0
							var total_paid = 0
							var deadline_reached = false

							const invoices = []
							for (const invoice of value.invoices) {
								total_debit += invoice.gross_total
								total_paid += invoice.paid_amount

								var icon = ''
								if (invoice.paid_amount > invoice.gross_total) {
									// Túlfizetett számla
									icon = '<i class="fa fa-file-invoice text-info"></i>'
								} else if (invoice.paid_amount >= invoice.gross_total) {
									// Fizetett számla
									icon = '<i class="fa fa-file-invoice text-success"></i>'
								} else if (invoice.paid_amount > 0) {
									// Részben fizetett számla
									icon = '<i class="fa fa-file-invoice text-warning"></i>'
								} else if (Anvil.moment(invoice.deadline_d).isBefore(Anvil.moment())) {
									// Lejárt számla
									icon = '<i class="fa fa-file-invoice text-danger"></i>'
									if (invoice.paid_amount < invoice.gross_total) {
										deadline_reached = true
									}
								} else {
									// Nem lejárt számla
									icon = '<i class="fa fa-file-invoice text-dim"></i>'
								}

								inv.push(icon)
								invoices.push(`
									<tr>
										<td><span class="me-2">${icon}</span>${invoice.invoice_nr}</td>
										<td>${Anvil.moment(invoice.invoice_d).format('YYYY. MM. DD.')}</td>
										<td class="text-end">${Anvil.numeral(invoice.gross_total).format('0,0')}</td>
										<td class="text-end">${invoice.paid_amount ? Anvil.numeral(invoice.paid_amount).format('0,0') : '-'}</td>
									</tr>
								`)
							}

							if (value.invoice_count > 0) {
								return `
									<div class="dropdown">
										<div class="period_mark" tabindex="0" data-bs-toggle="dropdown">
											<span class="${(total_paid == total_debit) ? 'text-success' : (deadline_reached ? (total_paid == 0 ? 'text-danger' : 'text-warning') : 'text-light')}">${value.net_total ? Anvil.numeral(value.net_total).format('0,0') : ''}</span><br />
											${(total_paid != total_debit) ? `<small class="text-info float-start px-1 rounded">${Anvil.numeral(total_paid / total_debit).format('%')}</small>` : ''}
											<small>${inv.join(' ')}</small>
										</div>
										<div class="dropdown-menu period_details shadow px-2">
											<table class="table table-sm w-100 mb-0">
												<thead>
													<tr>
														<th>Számla</th>
														<th>Kiállítva</th>
														<th class="text-end">Bruttó összeg</th>
														<th class="text-end">Fizetve</th>
													</tr>
												</thead>
												<tbody>
													${invoices.join('')}
												</tbody>
											</table>
										</div>
									</div>
								`
							} else {
								return `
									<div class="period_mark"></div>
								`
							}

						} else {
							return '-'
						}
					}

					const render_class = (row, field) => {
						const period_length = {
							'monthly': 1,
							'quarterly': 3,
							'half-yearly': 6,
							'annual': 12
						}[row.invoicing_period]

						const month = Anvil.moment().month() + 1
						const period_start = Math.floor((month - 1) / period_length) * period_length + 1
						const period_end = period_start + period_length - 1

						// If field is within the invoicing period
						const field_month = parseInt(field.replace('invoicing_', ''))
						const classes = [ 'text-end', 'overflow-visible' ]
						if ((Anvil.page.search.year == Anvil.moment().year()) && field_month >= period_start && field_month <= period_end) {
							classes.push('period_highlight')

							// Count the number of invoices in the period
							var invoices_in_period = 0
							for (m = period_start; m <= period_end; m++) {
								invoices_in_period += row[`invoicing_${m}`].invoice_count
							}

							if (invoices_in_period == 0) {
								classes.push('period_has_no_invoices')
							}
						}

						if ((field_month - 1) % period_length == 0) {
							classes.push('period_start')
						}
						if ((field_month - 1) % period_length == period_length - 1) {
							classes.push('period_end')
						}

						return classes.join(' ')
					}
					%>

					<%- include('/ui/grid', {
						name: 'invoicing',
						params: {
							selection_key: 'id',

							row_height: 48,
							render_footer (list, map) {
								//let net_total = 0
								let gross_total = 0
								let paid_amount = 0
								for (let company of map) {
									//net_total += company.net_total
									gross_total += company.gross_total
									paid_amount += company.paid_amount
								}
								return `Összes követelés (bruttó): <strong class="m-0 p-0" style="color:goldenrod;">${Anvil.numeral(gross_total).format('0,0')} Ft</strong><span class="mx-2">|</span>Kintlevőség: <strong class="m-0 p-0" style="color:orangered;">${Anvil.numeral(gross_total - paid_amount).format('0,0')} Ft</strong>`
							},
							columns: [
								{
									title: 'Adószám',
									field: 'tax_number',
									type: 'string',
									width: 120
								},
								{
									title: 'Név',
									field: 'name',
									type: {
										render (value, row, options) {
											var group = null
											if (row.group_id) {
												const company_group = Anvil.page.company_groups.getById(row.group_id)
												if (company_group != undefined) {
													group = company_group.name
												}
											}

											var dist = null
											if (row.distributor_id) {
												const distributor = Anvil.page.companies.getById(row.distributor_id)
												if (distributor != undefined) {
													dist = distributor.name
												}
											}

											var ref = null
											if (row.referer_id) {
												const referer = Anvil.page.companies.getById(row.referer_id)
												if (referer != undefined) {
													ref = referer.name
												}
											}

											return `
												<button class="btn btn-lg btn-dark ms-2 float-end btn-orb text-primary" onclick="Anvil.page.invoicing('${row.id}')"><i class="fa fa-print"></i></button>
												<strong>${value}</strong><br />
												<div class="float-end">
													${(row.service_partner ? '<div class="badge bg-warning">Pénztárgép szervíz</div>' : '')}
													${(row.referer ? '<div class="badge bg-success">Ajánló</div>' : '')}
													${(row.distributor ? '<div class="badge bg-primary">Disztribútor</div>' : '')}
												</div>
												${row.distributor_id ? `<div class="badge bg-dark ${row.distributor_id == 145 ? 'text-primary' : 'text-warning'} c_info" title="Disztibútor: ${dist}"><strong>${dist.substring(0, 3).toUpperCase()}</strong></div>` : ''}
												${row.referer_id ? `<div class="badge bg-success c_info" title="Ajánló: ${ref}"><strong>${ref.substring(0, 3).toUpperCase()}</strong></div>` : ''}
												${group ? `<div class="badge bg-dark text-dim">${group}</div>` : ''}
												`
										}
									},
									options: {
										cutoff: 40
									},
									width: 300
								},
								{
									title: 'Periódus',
									field: 'invoicing_period',
									type: {
										render (value) {
											return {
												'monthly': 'Havi',
												'quarterly': 'Negyedéves',
												'half-yearly': 'Féléves',
												'annual': 'Éves'
											}[value]
										}
									},
									width: 120
								},
								{
									title: 'Január',
									field: 'invoicing_1',
									sort: false,
									type: {
										render: render_month
									},
									options: {
										class: render_class
									},
									width: 100
								},
								{
									title: 'Február',
									field: 'invoicing_2',
									sort: false,
									type: {
										render: render_month
									},
									options: {
										class: render_class
									},
									width: 100
								},
								{
									title: 'Március',
									field: 'invoicing_3',
									sort: false,
									type: {
										render: render_month
									},
									options: {
										class: render_class
									},
									width: 100
								},
								{
									title: 'Április',
									field: 'invoicing_4',
									sort: false,
									type: {
										render: render_month
									},
									options: {
										class: render_class
									},
									width: 100
								},
								{
									title: 'Május',
									field: 'invoicing_5',
									sort: false,
									type: {
										render: render_month
									},
									options: {
										class: render_class
									},
									width: 100
								},
								{
									title: 'Június',
									field: 'invoicing_6',
									sort: false,
									type: {
										render: render_month
									},
									options: {
										class: render_class
									},
									width: 100
								},
								{
									title: 'Július',
									field: 'invoicing_7',
									sort: false,
									type: {
										render: render_month
									},
									options: {
										class: render_class
									},
									width: 100
								},
								{
									title: 'Augusztus',
									field: 'invoicing_8',
									sort: false,
									type: {
										render: render_month
									},
									options: {
										class: render_class
									},
									width: 100
								},
								{
									title: 'Szeptember',
									field: 'invoicing_9',
									sort: false,
									type: {
										render: render_month
									},
									options: {
										class: render_class
									},
									width: 100
								},
								{
									title: 'Október',
									field: 'invoicing_10',
									sort: false,
									type: {
										render: render_month
									},
									options: {
										class: render_class
									},
									width: 100
								},
								{
									title: 'November',
									field: 'invoicing_11',
									sort: false,
									type: {
										render: render_month
									},
									options: {
										class: render_class
									},
									width: 100
								},
								{
									title: 'December',
									field: 'invoicing_12',
									sort: false,
									type: {
										render: render_month
									},
									options: {
										class: render_class
									},
									width: 100
								}
							]
						},
						list: companies
					}) %>
				</div>
			</div>

			<div class="py-3">
				<button onclick="history.back()" class="btn btn-dark"><i class="fa fa-angle-left me-2"></i>Vissza</button>
				<div class="float-end">
					<button class="btn btn-primary" onclick="Anvil.page.invoicing_for_new_company()"><i class="fa fa-fw fa-plus"></i><span class="d-none d-md-inline ms-2">Számlázás új cégnek</span></button>
				</div>
			</div>

		</div>

	</div>
</div>

<script>
Object.assign(Anvil.page, {

	init () {
		Anvil.page.quickSearch()
	},

	searchModal () {
		Anvil.modal('/company/page_invoicing_search_modal', { search: Anvil.page.search })
	},

	quickSearch () {
		const filters = []
		const params = {
			sort_order: Anvil.page.search.sort_order
		}
		if (Anvil.page.search.company_group_id) {
			if (Anvil.page.search.company_group_id == -1) {
				filters.push(row => row.group_id === null)
				params.company_group_id = null
			} else {
				filters.push(row => row.group_id == Anvil.page.search.company_group_id)
				params.company_group_id = Anvil.page.search.company_group_id
			}
		}
		if (Anvil.page.search.company_tag_id) {
			const tag_id = parseInt(Anvil.page.search.company_tag_id)
			filters.push(row => row.tags.includes(tag_id))
			params.company_tag_id = tag_id
		}
		if (Anvil.page.search.invoicing_period) {
			filters.push(row => row.invoicing_period == Anvil.page.search.invoicing_period)
			params.invoicing_period = Anvil.page.search.invoicing_period
		}

		const expression = Anvil.page.search.expression
		if (expression) {
			params.expression = expression
		}

		if (filters.length > 0) {
			$('#filter-btn, #filter-btn-2').removeClass('btn-dark').addClass('btn-success')
			$('#filter-btn-badge, #filter-btn-badge-2').text(filters.length).removeClass('d-none')
		} else {
			$('#filter-btn, #filter-btn-2').removeClass('btn-success').addClass('btn-dark')
			$('#filter-btn-badge, #filter-btn-badge-2').text('').addClass('d-none')
		}

		// Generate URL
		window.history.replaceState({}, '', Anvil.href('/company/invoicing', params))

		Anvil.models.components.Grid.find('#invoicing_grid').filter(expression, filters)
	},

	refresh () {
		Anvil.exec('company/action_refresh_invoicing')
	},

	new () {
		Anvil.exec('company/modal_edit')
	},

	open () {
		let sel = Anvil.models.components.Grid.find('#company_grid').selected_rows
		if (sel.length > 0) {
			Anvil.exec('company/modal_edit', sel[0].id)
		}
	},

	delete () {
		let sel = Anvil.models.components.Grid.find('#company_grid').selected_rows
		if (sel.length > 0) {
			Anvil.exec('company/action_delete', sel[0].id)
		}
	},

	invoicing (company_id) {
		Anvil.exec('company/modal_invoicing', company_id)
	},

	invoicing_for_new_company () {
		Anvil.exec('company/modal_invoicing_for_new_company', {})
	}
})

$('#company_grid').on('dblclick', 'tbody tr', function () {
	Anvil.page.open()
})
</script>
